import "./Lifecycle.css";
import sdlcImg from "../../../../Assets/Images/sdlc.svg";

const Lifecycle = () => {
  return (
    <div id="our-process" className="lifecycle">
      <h1 className="lifecycle__title">Software Development Lifecycle</h1>

      <div className="lifecycle__container">
        <img src={sdlcImg} alt="software development lifecycle" />
      </div>
    </div>
  );
};

export default Lifecycle;
